import React, { useCallback, useMemo, useState } from "react";
import '.././popup.common.css'
import CustomModal from "../../Modal/CustomModal";
import CancelStep from "././CancelStep/CancelStep";
import RefundStep from "././RefundStep/RefundStep";
import ReasonStep from "././ReasonStep/ReasonStep";
import { formatDateLong } from "../../../Utils/utils";
import { getPaymentDetails } from "../../../APICalling/APICalling";
import { useGlobalContext } from "../../../Context/GlobalContext";
import CommissionHandlingStep from "./CommissionHandlingStep/CommissionHandlingStep";

const CancelBookingWithRefund = ({ onClose, onConfirm, buttonDisabled, cancellBookingWithoutRefund, sendRefundReq, bookingStatus, bookingDeposit }) => {
	const { bookingDetails, apiError, selectedSaleId } = useGlobalContext();
	const bookingType = String(bookingDetails?.booking_type || bookingDetails?.type || "booking").toLowerCase();
	const shouldShowCommissionStep = bookingType === "booking";
	const saleId = selectedSaleId || bookingDetails?.sale_id || bookingDetails?.sales_id;
	const isProductSale = bookingDetails?.booking_type === "product" || bookingDetails?.type === "product";
	const paymentQueryParams = useMemo(() => {
		if (!isProductSale || !bookingDetails?.id) return undefined;
		return { sale_id: bookingDetails.id };
	}, [isProductSale, bookingDetails?.id]);
	const [firstStep, setFirstStep] = useState(true);
	const [secondStep, setSecondStep] = useState(false);
	const [commissionStep, setCommissionStep] = useState(false);
	const [thirdStep, setThirdStep] = useState(false);
	const [paymentDetails, setPaymentDetails] = useState([]);
	const [commissionPayload, setCommissionPayload] = useState({
		clawback_commission: false,
		booking_item_ids: [],
		remark: ""
	});

	const skipRefundDisabled = bookingStatus?.toLowerCase() === 'cancelled' && Number(bookingDeposit || 0) > 0;
	
	
		//   const [loading, setLoading] = useState(true);
		
	const fetchPaymentDetails = async () => {
	try {
	//   setLoading(true);
		if (!saleId) return;
		const response = await getPaymentDetails(saleId, paymentQueryParams);
		const data = response.data.data;
		// console.log("Payment Details:", data);
		setPaymentDetails(data || []);
	} catch (error) {
		console.error("Error:", error);
	} finally {
	//   setLoading(false);
	}
	};

	const goToRefund = () => {
		setFirstStep(false);
		setSecondStep(true);
		fetchPaymentDetails();
	}
	const goToReason = () => {
		setFirstStep(false);
		setSecondStep(false);
		setCommissionStep(false);
		setThirdStep(true);
	}

	const goToCommission = () => {
		setFirstStep(false);
		setSecondStep(false);
		setCommissionStep(shouldShowCommissionStep);
		setThirdStep(!shouldShowCommissionStep);
	}

	
	const backStep = () => {
		setFirstStep(false);
		setThirdStep(false);
		setCommissionStep(shouldShowCommissionStep);
		setSecondStep(!shouldShowCommissionStep);
	}

	const backToCancelStep = () => {
		setFirstStep(true);
		setSecondStep(false);
		setCommissionStep(false);
		setThirdStep(false);
	}

	const backToRefund = () => {
		setFirstStep(false);
		setSecondStep(true);
		setCommissionStep(false);
		setThirdStep(false);
	}

	const handleCommissionChange = useCallback((payload) => {
		setCommissionPayload(payload);
	}, []);

	const handleSendRefundReq = () => {
		sendRefundReq(
			shouldShowCommissionStep
				? commissionPayload
				: { clawback_commission: false, booking_item_ids: [], remark: "" }
		);
	};

	return (
		<CustomModal
			modalClass={`cancelBookingPopup`}
			show={true}
			onHide={onClose}
		>
		{firstStep && (
			<CancelStep 
				onConfirm={onConfirm}
				onClose={onClose}
				status={bookingDetails?.status?.toLowerCase()}
				nextStep={goToRefund}
				error={apiError}
				buttonDisabled={buttonDisabled}
				bookingStatus={bookingStatus}
				bookingDeposit={bookingDeposit}
			/>
		)}
		{secondStep && (
			<RefundStep
				onClose={onClose}
				// bookingDetails={bookingDetails}
				paymentDetails={paymentDetails}
				createdDate={formatDateLong(bookingDetails.created_at)}
				status={bookingDetails?.status?.toLowerCase()}
				deposit={bookingDetails.deposit}
				nextStep={goToCommission}
				previousStep={backToCancelStep}
				// sendRefundReq={sendRefundReq}
				// voidSale={cancellBookingWithoutRefund}
				voidSale={() => cancellBookingWithoutRefund('Cancelled')}
				skipRefundDisabled={skipRefundDisabled}
				heading="Refund Deposit"
			/>
		)}
		{commissionStep && shouldShowCommissionStep && (
			<CommissionHandlingStep
				saleId={saleId}
				backStep={backToRefund}
				nextStep={goToReason}
				onCommissionChange={handleCommissionChange}
			/>
		)}
		{thirdStep && (
			<ReasonStep
				onClose={onClose}
				backStep={backStep}
				sendRefundReq={handleSendRefundReq}
				heading="Specify Refund Reason"
				para="Please select a refund reason and proceed with the refund request"
				action="cancelBooking"
			/>
		)}

		</CustomModal>
	);
};

export default CancelBookingWithRefund;
